/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable object-shorthand */
/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';

import { CardBody, Col, Container, Row } from 'reactstrap';
import './tiposfaltas.css';
// PACKAGES
import { useDispatch, useSelector } from 'react-redux';

import { Button, Box, InputAdornment, IconButton, TextField } from '@mui/material';
import MUIDataTable from 'mui-datatables';

// COMPONENTS
import ModalEdit from './components/modalEdit';
import ModalDelete from './components/modalDelete';
import ModalAdicionar from './components/modalAdicionar';
import BreadTiposFaltas from '../../../App/Breadcrumbs/Administracao/TiposFaltas/BreadTiposFaltas';
import FooterLinks from '../../../Account/Footer';

// ACTIONS
import GetTiposFaltas from '../../../../redux/actions/TiposFaltasAction/tiposFaltasAction';
import GetTipoFalta from '../../../../redux/actions/TiposFaltasAction/getTipoFaltaAction';

import Notification from 'rc-notification';
import { FullWideNotification } from '../../../../shared/components/Notification';
import { FiEdit, FiPlus, FiSearch, FiTrash2 } from 'react-icons/fi';

let notificationTC = null;

function TiposFaltas(theme) {
  const [responsive] = useState('standard');
  const [tableBodyHeight] = useState('100%');
  const [tableBodyMaxHeight] = useState('');
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [tipoFalta, setTipoFalta] = useState({
    descricao: '',
    abreviatura: '',
  });
  const [tipoFaltaId, setTipoFaltaId] = useState();
  const [tipoFaltaNome, setTipoFaltaNome] = useState();
  const [errorsTipoFalta, setErrorsTipoFalta] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // ====================== Search Text ====================== //

  const [searchText, setSearchText] = useState();

  // ========================================================= //

  const resetTipoFalta = () => {
    setTipoFalta({
      descricao: '',
      abreviatura: '',
    });
  };

  const tiposFaltas = useSelector((state) => state.tiposFaltas.tiposFaltas);

  const fetchTiposFaltas = () => {
    dispatch(GetTiposFaltas());
    dispatch({ type: 'CLEAR_DATA_TIPOFALTA' });
  };

  const tipoFaltaInfo = useSelector((state) => state.tiposFaltas.tipoFalta);

  const fetchTipoFalta = (id, e) => {
    e.preventDefault();
    return dispatch(GetTipoFalta(id));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchTiposFaltas();
  }, []);

  const handleOpen = (btn, e, id, tableMeta) => {
    e.preventDefault();
    setErrorsTipoFalta({});
    setLoading(false);
    if (btn == 'edit') {
      setTipoFaltaId(id);
      setTipoFaltaNome(tableMeta.rowData[0]);
      fetchTipoFalta(id, e).then(() => setOpenEdit(true));
    } else if (btn == 'delete') {
      setOpenDelete(true);
      setTipoFaltaId(id);
      setTipoFaltaNome(tableMeta.rowData[0]);
    } else {
      setOpenAdicionar(true);
      resetTipoFalta();
    }
  };

  const handleClose = (btn, e) => {
    e.preventDefault();
    setErrorsTipoFalta({});
    if (btn == 'edit') {
      setOpenEdit(false);
      // dispatch({ type: 'CLEAR_DATA_TIPOFALTA' });
    } else if (btn == 'delete') {
      setOpenDelete(false);
    } else {
      setOpenAdicionar(false);
      setErrorsTipoFalta({});
    }
  };

  const columns = [
    {
      name: 'descricao',
      label: 'Descrição',
    },
    {
      name: 'abreviatura',
      label: 'Abreviatura',
    },
    {
      name: 'id',
      label: ' ',
      options: {
        filter: true,
        sort: false,
        empty: true,
        setCellProps: () => ({
          align: 'right',
        }),
        customBodyRender: (value, tableMeta) => {
          console.log(value);
          return (
            <div className="table-btns-tiposfaltas">
              <Button
                onClick={(e) =>
                  // window.alert(`Clicked "Edit" for row ${tableMeta.rowIndex}`)
                  handleOpen('edit', e, value, tableMeta)
                }
              >
                <FiEdit size={30} strokeWidth={1} color="#000" />
              </Button>

              <Button
                onClick={(e) => {
                  handleOpen('delete', e, value, tableMeta);
                }}
              >
                <FiTrash2 size={30} strokeWidth={1} color="#000" />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    filterType: 'dropdown',
    search: false,
    searchText: searchText,
    print: false,
    download: false,
    selectableRows: 'none',
    viewColumns: false,
    responsive,
    tableBodyHeight,
    tableBodyMaxHeight,
    elevation: 0,

    // customToolbar: () => {
    //   return <CustomToolbar handleOpen={handleOpen} />;
    // },
    textLabels: {
      body: {
        noMatch: 'Sem Registos encontrados',
        columnHeaderTooltip: (column) => `${column.label}`,
      },
      toolbar: {
        search: 'Pesquisar',
      },
      pagination: {
        next: 'Proxima Página',
        previous: 'Página Anterior',
        rowsPerPage: 'Mostrar:',
        displayRows: 'de',
      },
    },
  };

  // -------------------------- Validacao tipos de faltas --------------------//

  const validationTipoFalta = (fieldValues = tipoFalta) => {
    const temp = { ...errorsTipoFalta };
    if ('descricao' in fieldValues)
      temp.descricao = fieldValues.descricao ? '' : 'Campo Obrigatório';
    if ('abreviatura' in fieldValues)
      temp.abreviatura = fieldValues.abreviatura ? '' : 'Campo Obrigatório';

    setErrorsTipoFalta({
      ...temp,
    });
    if (fieldValues == tipoFalta) {
      return Object.values(temp).every((x) => x == '');
    }
    return false;
  };

  // -----------------------------------------------------------------------//

  // ---------- Notification Sytem ------------------- //

  useEffect(() => {
    Notification.newInstance({ style: { top: 65, zIndex: 9999 } }, (n) => {
      notificationTC = n;
    });
  }, [dispatch]);

  const showNotification = ({ notification, position }, direction) => {
    const notificationDefaultProps = {
      content: notification(theme),
      duration: 2,
      closable: true,
      className: `${position} ${direction}-support`,
    };

    notificationTC.notice({
      ...notificationDefaultProps,
      style: { top: -60, left: 0 },
    });
  };

  const show = (color, mensagem) =>
    showNotification({
      notification() {
        return <FullWideNotification color={color} message={mensagem} theme={theme} />;
      },
      position: 'full',
    });

  // ----------------------------------------------- //

  return (
    <>
      <Container>
        <Row>
          <Col md={12}>
            <BreadTiposFaltas />
            <h4
              style={{
                fontSize: '22px',
                width: '100%',
                marginTop: 20,
                marginBottom: 20,
              }}
              className="text-underline"
            >
              Tipos de Faltas
            </h4>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <>
              {/* <Snackbar open={openSnackDelete} autoHideDuration={3000} onClose={handleCloseAlert}>
                  <Alert onClose={handleCloseAlert} severity="success">
                    Tipo de falta removido com sucesso!
                  </Alert>
                </Snackbar> */}

              {/* <Snackbar open={openSnackAdd} autoHideDuration={3000} onClose={handleCloseAlert}>
                  <Alert onClose={handleCloseAlert} severity="success">
                    Tipo de falta adicionado com sucesso!
                  </Alert>
                </Snackbar> */}

              <ModalAdicionar
                openAdicionar={openAdicionar}
                handleClose={handleClose}
                tipoFalta={tipoFalta}
                setTipoFalta={setTipoFalta}
                validationTipoFalta={validationTipoFalta}
                errorsTipoFalta={errorsTipoFalta}
                fetchTiposFaltas={fetchTiposFaltas}
                show={show}
                // Loading
                loading={loading}
                setLoading={setLoading}
              />
              {/* <MuiThemeProvider theme={myTheme}> */}
              <ModalEdit
                openEdit={openEdit}
                handleClose={handleClose}
                tipoFalta={tipoFalta}
                setTipoFalta={setTipoFalta}
                validationTipoFalta={validationTipoFalta}
                errorsTipoFalta={errorsTipoFalta}
                fetchTiposFaltas={fetchTiposFaltas}
                tipoFaltaInfo={tipoFaltaInfo}
                tipoFaltaId={tipoFaltaId}
                tipoFaltaNome={tipoFaltaNome}
                show={show}
                // Loading
                loading={loading}
                setLoading={setLoading}
              />
              <ModalDelete
                openDelete={openDelete}
                handleClose={handleClose}
                tipoFaltaId={tipoFaltaId}
                fetchTiposFaltas={fetchTiposFaltas}
                tipoFalta={tipoFalta}
                tipoFaltaNome={tipoFaltaNome}
                show={show}
                // Loading
                loading={loading}
                setLoading={setLoading}
              />
              <CardBody>
                <Col md={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <Box>
                      <b>Pesquisar</b>
                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        name="search"
                        type="text"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <FiSearch />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <Box sx={{ ml: 2 }}>
                      <Button
                        sx={{ border: '1px solid #000', minWidth: '45px', mt: 2.5 }}
                        onClick={(e) => handleOpen('add', e)}
                      >
                        <FiPlus size={25} strokeWidth={1.5} />
                      </Button>
                    </Box>
                  </Box>
                  <Box sx={{ borderBottom: '1px solid #000', mb: 3 }}>
                    <h4
                      style={{
                        width: '100%',
                      }}
                      className="text-underline-title"
                    >
                      Tipos de Faltas
                    </h4>
                  </Box>
                  <MUIDataTable
                    description="Nada para mostrar"
                    data={tiposFaltas}
                    columns={columns}
                    options={options}
                  />
                </Col>
              </CardBody>
              {/* </MuiThemeProvider> */}
            </>
          </Col>
        </Row>
      </Container>
      <div className="bottom">
        <div style={{ padding: '20px 40px' }}>
          <FooterLinks />
        </div>
      </div>
    </>
  );
}

export default TiposFaltas;
